/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
'use strict';

const isContainer = require('./isContainer');

/**
 * @function isContainer
 */
module.exports = function (Container) {
  return !!(isContainer(Container) && Container.isRootContainer);
};
